import { formatDistanceToNow } from 'date-fns';
import type { CrmRequiredActionItem } from '../crm/requiredActions';
import { getRequiredActionTimestamp } from '../crm/requiredActions';

export interface ProposalRequiredActionRow {
  id: string;
  title: string;
  status: string;
  customer_id: string;
  updated_at: string;
  created_at: string;
  proposal_number?: number | null;
  pipeline_opportunities_id?: number | string | null;
  customer_name?: string;
  /** Sum of completed deposit payments linked to this proposal. */
  deposit_amount?: number;
}

export function buildProposalRequiredActions(
  proposals: ProposalRequiredActionRow[],
  now: Date = new Date(),
): CrmRequiredActionItem[] {
  const items: CrmRequiredActionItem[] = [];

  for (const proposal of proposals) {
    if (proposal.status !== 'approved') continue;

    const title =
      proposal.title?.trim() ||
      (proposal.proposal_number ? `Proposal #${proposal.proposal_number}` : 'Untitled proposal');
    const customerName = proposal.customer_name?.trim() || 'Unknown contact';
    const updatedAt = proposal.updated_at || proposal.created_at;
    const updated = new Date(updatedAt);
    const updatedMs = updated.getTime();
    const depositAmount =
      typeof proposal.deposit_amount === 'number' && proposal.deposit_amount > 0
        ? proposal.deposit_amount
        : undefined;
    const linked = Number(proposal.pipeline_opportunities_id);
    const opportunityId = Number.isFinite(linked) && linked > 0 ? linked : undefined;

    items.push({
      kind: 'proposal_convert',
      proposalId: proposal.id,
      opportunityId,
      title,
      customerName,
      subtitle: Number.isNaN(updatedMs)
        ? 'Approved · convert to booking'
        : `Approved ${formatDistanceToNow(updated, { addSuffix: true })} · convert to booking`,
      sortOrder: Number.isNaN(updatedMs) ? now.getTime() : updatedMs,
      createdAt: updatedAt,
      depositAmount,
    });
  }

  items.sort((a, b) => getRequiredActionTimestamp(b) - getRequiredActionTimestamp(a));
  return items;
}
